import React, { useRef, useState } from "react";
import { Steps, Button } from "antd";
import { Provider } from "./multiStepFormContext";

const { Step } = Steps;

const MultiStepForm = ({ steps, onSubmit, className = '' }) => {
  const ref = useRef();
  const [formData, setFormData] = useState({});
  const [currentStep, setCurrentStep] = useState(0);

  const submit = () => {
    if (ref.current?.validate()) {
      onSubmit(formData);
    }
  }

  const next = async () => {
      if (await ref.current?.validate() && currentStep !== steps.length - 1) {
        setCurrentStep(currentStep + 1);
      }
  };

  const prev = () => {
    if (currentStep > 0) {
      setCurrentStep(currentStep - 1);
    }
  };

  const renderCurrentStep = () => {
    const StepComponent = steps[currentStep].component;
    return <StepComponent ref={ref} formData={formData} setFormData={setFormData} />;
  };

  return (
    <Provider value={{ formData, setFormData }}>
      <div className={`${className} mobile-block`}>
        <Steps current={currentStep}>
          {steps.map((step, index) => (
            <Step key={index} title={step.title}  />
          ))}
        </Steps>
        <main className="mb-4">{renderCurrentStep()}</main>
        <div className="d-flex flex-row-reverse justify-content-between">
        {currentStep < steps.length - 1 ? (
            <Button onClick={next}>
              Siguiente
            </Button>
          ) : (
            <Button onClick={submit}>
              Finalizar
            </Button>
          )}
          {currentStep > 0 && (
            <Button className="back-button" onClick={prev}>
              Volver
            </Button>
          )}
        </div>
      </div>
    </Provider>
  );
};

export default MultiStepForm;
